// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Universe Pokémon - Main Export
 * 
 * Aggregates all configuration for the Pokémon universe.
 * A universe where Pokémon have evolved across different planets,
 * each region from the games is now a star system.
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { PokemonAliensPlanets } from './AliensConfig';

export const universePokemon = {
  id: 'pokemon',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: PokemonAliensPlanets,
};

export default universePokemon;
